export class UrlUtils {
    /**
     * Replaces the query string parameters on the current URL in browser's history.
     * Doesn't navigate or reload the current page.
     * @param key the key to look for in the query string.
     * @param value the value to set in the query string.
     */
    public static updateQueryStringParam(key: string, value: string) {
        const baseUrl = [location.protocol, '//', location.host, location.pathname].join('');
        const urlQueryString = document.location.search;
        const newParam = key + '=' + value;
        let params = '?' + newParam;

        // If the "search" string exists, then build params from it
        if (urlQueryString) {
            const keyRegex = new RegExp('([\?&])' + key + '[^&]*');

            // If param exists already, update it
            // If value is undefined, then the param will be removed
            if (urlQueryString.match(keyRegex) !== null) {
                params = urlQueryString.replace(keyRegex, value ? ('$1' + newParam) : '');
                if (params.startsWith('&')) {
                    params = '?' + params.substring(1);
                }
            } else { // Otherwise, add it to end of query string
                params = urlQueryString + '&' + newParam;
            }
        }
        window.history.replaceState({}, '', baseUrl + params);
    }
}
